/**
 * Enova - Event Hero
 * - Countdown timer (data-event-date)
 * - Quantity selector (+/- buttons + input)
 * - Product form submission is handled by the browser natively
 *   since it's a standard POST form to /cart/add.
 */
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function initCountdown(root) {
    var els = root.querySelectorAll('[data-event-countdown]');
    if (!els.length) return;

    var first = els[0];
    var dateStr = first.getAttribute('data-event-date');
    if (!dateStr) return;

    var target = new Date(dateStr).getTime();
    if (isNaN(target)) return;

    var finishedText = first.getAttribute('data-finished-text') || '';

    function setText(text) {
      for (var i = 0; i < els.length; i++) {
        els[i].textContent = text;
      }
    }

    function update() {
      var now = Date.now();
      var diff = target - now;

      if (diff <= 0) {
        setText(finishedText);
        clearInterval(timer);
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setText(
        pad(days) + 'd : ' +
        pad(hours) + 'h : ' +
        pad(minutes) + 'm : ' +
        pad(seconds) + 's'
      );
    }

    update();
    var timer = setInterval(update, 1000);
  }

  function initQuantity(root) {
    var wrap = root.querySelector('[data-quantity]');
    if (!wrap) return;

    var input = wrap.querySelector('input[type="number"]');
    var minus = wrap.querySelector('[data-quantity-minus]');
    var plus = wrap.querySelector('[data-quantity-plus]');
    if (!input || !minus || !plus) return;

    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10) || 99;

    function clamp(val) {
      val = parseInt(val, 10);
      if (isNaN(val)) val = min;
      if (val < min) val = min;
      if (val > max) val = max;
      return val;
    }

    function sync() {
      input.value = clamp(input.value);
      minus.disabled = parseInt(input.value, 10) <= min;
      plus.disabled = parseInt(input.value, 10) >= max;
    }

    minus.addEventListener('click', function (e) {
      e.preventDefault();
      input.value = clamp(parseInt(input.value, 10) - 1);
      sync();
    });

    plus.addEventListener('click', function (e) {
      e.preventDefault();
      input.value = clamp(parseInt(input.value, 10) + 1);
      sync();
    });

    input.addEventListener('change', sync);
    sync();
  }

  function readConfig(root) {
    var config = {
      sizesEnable: false,
      sizeOptions: [],
      garmentOptions: [],
      propertyLabel: 'Talla',
      setLabel: 'Set',
    };
    var el = root.querySelector('[data-event-hero-config]');
    if (!el) return config;
    try {
      var parsed = JSON.parse(el.textContent);
      config.sizesEnable = !!parsed.sizesEnable;
      config.sizeOptions = (parsed.sizeOptions || [])
        .map(function (s) { return String(s).trim(); })
        .filter(Boolean);
      config.garmentOptions = (parsed.garmentOptions || [])
        .map(function (s) { return String(s).trim(); })
        .filter(Boolean);
      if (parsed.propertyLabel) config.propertyLabel = String(parsed.propertyLabel).trim();
      if (parsed.setLabel) config.setLabel = String(parsed.setLabel).trim();
    } catch (e) {
      if (window.console && console.warn) {
        console.warn('[enova-event-hero] Invalid config JSON:', e);
      }
    }
    return config;
  }

  function initPurchase(root) {
    var form = root.querySelector('form.enova-event-hero__form');
    if (!form) return;

    var button = form.querySelector('.enova-event-hero__buy');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    var config = readConfig(root);
    var modal = root.querySelector('[data-size-modal]');
    var useSizes =
      config.sizesEnable && modal && config.sizeOptions.length > 0 && config.garmentOptions.length > 0;

    function getQty() {
      var v = parseInt(qtyInput && qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      return v;
    }

    function setBuyLoading(state) {
      if (!button) return;
      button.disabled = state;
      if (state) button.setAttribute('data-loading', 'true');
      else button.removeAttribute('data-loading');
    }

    // Adds a single line item (id + quantity + optional properties) and goes to checkout.
    function addToCart(item, onError) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(item),
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error((data && data.description) || 'Add to cart failed');
            });
          }
          return response.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          if (window.console && console.warn) {
            console.warn('[enova-event-hero] Buy failed:', err);
          }
          if (onError) onError(err);
        });
    }

    // ---- No size selector: add the ticket directly ----
    if (!useSizes) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        setBuyLoading(true);
        addToCart({ id: idInput.value, quantity: getQty() }, function () {
          setBuyLoading(false);
          form.submit(); // native fallback
        });
      });
      return;
    }

    // ---- Size selector popup: one size per ticket/set ----
    // Move the modal to <body> so position:fixed covers the whole viewport even if
    // an ancestor (smooth-scroll wrapper / transformed section) traps fixed positioning.
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    var setsWrap = modal.querySelector('[data-size-sets]');
    var confirmBtn = modal.querySelector('[data-size-confirm]');
    var errorEl = modal.querySelector('[data-size-error]');
    var closers = modal.querySelectorAll('[data-size-close]');
    // selections[setIndex] = { "Top": "M", "Legging": null, ... }
    var selections = [];

    function validate() {
      var ok =
        selections.length > 0 &&
        selections.every(function (set) {
          return config.garmentOptions.every(function (garment) {
            return !!(set && set[garment]);
          });
        });
      if (confirmBtn) confirmBtn.disabled = !ok;
      if (ok && errorEl) errorEl.hidden = true;
      return ok;
    }

    function buildRow(index, total) {
      var set = document.createElement('div');
      set.className = 'enova-event-hero__set';

      if (total > 1) {
        var setLabel = document.createElement('span');
        setLabel.className = 'enova-event-hero__set-label';
        setLabel.textContent = config.setLabel + ' ' + (index + 1);
        set.appendChild(setLabel);
      }

      config.garmentOptions.forEach(function (garment) {
        var row = document.createElement('div');
        row.className = 'enova-event-hero__garment-row';

        var label = document.createElement('span');
        label.className = 'enova-event-hero__garment-label';
        label.textContent = garment;
        row.appendChild(label);

        var opts = document.createElement('div');
        opts.className = 'enova-event-hero__sizes';

        config.sizeOptions.forEach(function (size) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'enova-event-hero__size';
          b.textContent = size;
          b.setAttribute('data-size', size);
          b.setAttribute('aria-pressed', 'false');
          b.addEventListener('click', function () {
            selections[index][garment] = size;
            var siblings = opts.querySelectorAll('.enova-event-hero__size');
            for (var k = 0; k < siblings.length; k++) {
              siblings[k].classList.remove('is-selected');
              siblings[k].setAttribute('aria-pressed', 'false');
            }
            b.classList.add('is-selected');
            b.setAttribute('aria-pressed', 'true');
            validate();
          });
          opts.appendChild(b);
        });

        row.appendChild(opts);
        set.appendChild(row);
      });

      setsWrap.appendChild(set);
    }

    function prefersReducedMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function animateIn() {
      var frame = modal.querySelector('.enova-event-hero__modal-frame');
      var items = modal.querySelectorAll(
        '.enova-event-hero__modal-title, .enova-event-hero__modal-subtitle, .enova-event-hero__set-label, .enova-event-hero__garment-row, .enova-event-hero__modal-confirm'
      );

      // The overlay always fades in via CSS (reliable, independent of GSAP).
      if (prefersReducedMotion()) {
        modal.classList.remove('is-css-anim');
        return;
      }

      if (window.gsap && frame) {
        modal.classList.remove('is-css-anim');
        window.gsap.killTweensOf(frame);
        if (items.length) window.gsap.killTweensOf(items);

        var tl = window.gsap.timeline();
        tl.from(
          frame,
          { opacity: 0, y: 24, scale: 0.96, duration: 0.45, ease: 'power3.out', clearProps: 'opacity,transform' },
          0
        );
        if (items.length) {
          tl.from(
            items,
            { opacity: 0, y: 14, duration: 0.35, ease: 'power2.out', stagger: 0.06, clearProps: 'opacity,transform' },
            0.12
          );
        }
      } else {
        // CSS fallback: display:none -> flex on each open restarts the keyframe.
        modal.classList.add('is-css-anim');
      }
    }

    function openModal() {
      var n = getQty();
      selections = [];
      for (var s = 0; s < n; s++) {
        var set = {};
        config.garmentOptions.forEach(function (garment) {
          set[garment] = null;
        });
        selections.push(set);
      }
      setsWrap.innerHTML = '';
      for (var i = 0; i < n; i++) buildRow(i, n);
      if (errorEl) errorEl.hidden = true;
      validate();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      animateIn();
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.removeAttribute('data-loading');
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      openModal();
    });

    for (var c = 0; c < closers.length; c++) {
      closers[c].addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        if (!validate()) {
          if (errorEl) errorEl.hidden = false;
          return;
        }
        confirmBtn.disabled = true;
        confirmBtn.setAttribute('data-loading', 'true');

        var item = { id: idInput.value, quantity: selections.length, properties: {} };
        var multi = selections.length > 1;
        selections.forEach(function (set, i) {
          config.garmentOptions.forEach(function (garment) {
            var key = config.propertyLabel + ' ' + garment;
            if (multi) key += ' (' + config.setLabel + ' ' + (i + 1) + ')';
            item.properties[key] = set[garment];
          });
        });

        addToCart(item, function (err) {
          confirmBtn.disabled = false;
          confirmBtn.removeAttribute('data-loading');
          if (errorEl) {
            errorEl.hidden = false;
            if (err && err.message) errorEl.textContent = err.message;
          }
        });
      });
    }
  }

  function init() {
    var sections = document.querySelectorAll('.enova-event-hero');
    sections.forEach(function (section) {
      initCountdown(section);
      initQuantity(section);
      initPurchase(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
